export const MENU_ITEMS ={
    home:"Accueil",
    about:"A propos",
    media:"Media",
    contact:"Contact"
}
